export default function calcZoom(height, width, currZoom) {
  let widthZoom = 24;
  let heightZoom = 24;

  if (width < 1485 && width >= 985) {
    widthZoom = 3.4 + (((width - 985) / 500) * 1.4);
  }

  if (height < 1068 && height >= 415) {
    heightZoom = 3.25 + (((height - 415) / 618) * 1.55);
  }

  return Math.min(currZoom, widthZoom, heightZoom);
}